import React from 'react';
import { useTranslation } from 'react-i18next';
import './Contact.css';

interface PhoneInfo {
  number: string;
  label?: string;
}

interface OfficeInfo {
  title: string;
  address: string;
  phones: PhoneInfo[];
  email: string;
  hours: {
    weekdays: string;
    saturday?: string;
    sunday?: string;
  };
}

const Contact: React.FC = () => {
  const { t } = useTranslation();

  const offices: OfficeInfo[] = [
    {
      title: t('contact.offices.turkey.title'),
      address: 'K.Bakkalköy Mh. Dereboyu Cd. Brandium Office Center, R5 Blok, No:48 Ataşehir - İstanbul - Türkiye',
      phones: [
        { number: '+90 216 807 27 27', label: 'headquarters' },
        { number: '+90 540 807 27 27', label: 'projectManagement' }
      ],
      email: 'nish@nishglobal.tr',
      hours: {
        weekdays: t('contact.offices.turkey.hours.weekdays'),
        saturday: t('contact.offices.turkey.hours.saturday'),
        sunday: t('contact.offices.turkey.hours.sunday')
      }
    },
    {
      title: t('contact.offices.azerbaijan.title'),
      address: 'Gence Şehri, Mehmed Xelefov 90',
      phones: [
        { number: '+994 70 830 83 35' }
      ],
      email: 'nish@nishglobal.tr',
      hours: {
        weekdays: t('contact.offices.azerbaijan.hours.weekdays')
      }
    },
    {
      title: t('contact.offices.uzbekistan.title'),
      address: 'Toshkent Viloyeti Olmalıq Shahri',
      phones: [
        { number: '+998 77 317 83 34', label: 'mobile' }
      ],
      email: 'nish@nishglobal.tr',
      hours: {
        weekdays: t('contact.offices.uzbekistan.hours.weekdays'),
        saturday: t('contact.offices.uzbekistan.hours.saturday')
      }
    },
    {
      title: t('contact.offices.egypt.title'),
      address: 'Second Cairo Madinaty B3 New Cairo Cairo',
      phones: [
        { number: '+20 102 815 5990', label: 'mobile' },
        { number: '+20 11 52587717', label: 'mobile' }
      ],
      email: 'nish@nishglobal.tr',
      hours: {
        weekdays: t('contact.offices.egypt.hours.weekdays'),
        saturday: t('contact.offices.egypt.hours.saturday')
      }
    }
  ];


  return (
    <div className="contact-page">
      <div className="contact-hero">
        <div className="contact-hero-inner">
          <h1>{t('contact.title')}</h1>
          <p className="contact-hero-subtitle">{t('contact.subtitle')}</p>
        </div>
      </div>

      <div className="contact-container">

        <div className="offices-section">
          <div className="offices-grid">
            {offices.map((office, index) => (
              <div key={index} className="office-card">
                <h3>{office.title}</h3>
                <div className="office-info">
                  <div className="office-item">
                    <h4>{t('contact.address')}</h4>
                    <p>{office.address}</p>
                  </div>
                  <div className="office-item">
                    <h4>{t('contact.phones')}</h4>
                    {office.phones.map((phone, phoneIndex) => (
                      <p key={phoneIndex} className="phone-item">
                        <a href={`tel:${phone.number.replace(/\s/g, '')}`}>{phone.number}</a>
                        {phone.label && (
                          <span className="phone-label">
                            {' ('}
                            {t(`contact.phoneLabels.${phone.label}`)}
                            {')'}
                          </span>
                        )}
                      </p>
                    ))}
                  </div>
                  <div className="office-item">
                    <h4>{t('contact.email')}</h4>
                    <p>
                      <a href={`mailto:${office.email}`}>{office.email}</a>
                    </p>
                  </div>
                  <div className="office-item">
                    <h4>{t('contact.hours')}</h4>
                    <p>{office.hours.weekdays}</p>
                    {office.hours.saturday && <p>{office.hours.saturday}</p>}
                    {office.hours.sunday && <p>{office.hours.sunday}</p>}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;

